export default __webpack_public_path__ + "assets/home-one-one.e147b18c4af2dd3e34c913c8d16a458d.png";